import { AlertBannerContainerProps } from "./index";

export const findActiveAlertBanner = (
  alertBanners: AlertBannerContainerProps["data"]["allKontentItemComponentAlertBanner"]["nodes"]
) => {
  const today = new Date();

  const alertBanner = alertBanners.find((banner) => {
    const publish = new Date(banner?.elements?.publish_date?.value);
    const unpublish =
      banner?.elements?.unpublish_date?.value &&
      new Date(banner?.elements?.unpublish_date?.value);

    if (!!unpublish && today > unpublish) {
      return false;
    }

    if (today > publish) {
      return true;
    }

    return false;
  });

  return alertBanner;
};
